$(".js-vinNumber").find("strong").each(function() {
    var $this = $(this);
    var characters = $this.text().split("");
    var newCharacters = "";

    $this.empty();

    $.each(characters, function(i, char) {
        if (["i", "o", "q"].some(function(badChar) {
            return badChar === char.toLowerCase();
        })) {
            newCharacters += "<span class='text-decoration-underline'>" + char + "</span>";
        } else {
            newCharacters += char;
        }
    });

    $this.html(newCharacters);
});
